export default {
  apiKey: "AIzaSyDzWOws719QaX3AkgzsJOd2Jgu_qBPLybg",
  authDomain: "gree-commercial.firebaseapp.com",
  projectId: "gree-commercial",
  storageBucket: "gree-commercial.appspot.com",
  messagingSenderId: "215600867446",
  appId: "1:215600867446:web:c5d28309506517f1e49757",
  measurementId: "G-JZSRHZBCF4"
};